import { ImageUrlKey, getImage, preloadImages } from '../utils/getImage';

const problemCanvasImageKeys: ImageUrlKey[] = [
  'audioIcon',
  'audioStopIcon',
  'check',
  'checklight',
  'checkwhite',
  'gear',
  'gear2',
  'LINE_DOTTED_NO_ARROWS',
  'LINE_SOLID_NO_ARROWS',
  'loadingwheel',
  'pencilenabled',
  'thumbsUp',
  'trash',
  'trashlight',
  'trashwhite',
];

export const initImages = function (): void {
  getImage('trash');
  getImage('trashwhite');
  getImage('trashlight');
  getImage('check');
  getImage('checkwhite');
  getImage('checklight');
  getImage('thumbsUp');
};

/**
 * Ensures built-in problem.js image assets are fully loaded before a capture
 * workflow snapshots a canvas. This covers UI icons that are drawn via
 * getImage(...) but do not participate in the ImageLoadedListener observer.
 */
export const preloadProblemCanvasImages = async function (): Promise<void> {
  await preloadImages(problemCanvasImageKeys);
};
